"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateObject = exports.createReducer = exports.listen = exports.resetSubmitStates = exports.listenToFetchActions = exports.convertInputErrorToMessageError = exports.convertDataKeyToStateKeys = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _first = _interopRequireDefault(require("lodash/first"));

var _get = _interopRequireDefault(require("lodash/get"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var convertDataKeyToStateKeys = function convertDataKeyToStateKeys(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ccKey = (0, _camelCase["default"])(key);
  return {
    retrievingKey: options.retrievingKey || "".concat(ccKey, "Retrieving"),
    responseKey: options.responseKey || "".concat(ccKey, "Response"),
    errorKey: options.errorKey || "".concat(ccKey, "Error"),
    errorStatus: options.errorStatus || "".concat(ccKey, "ErrorStatus"),
    extraArgsKey: options.extraArgsKey || "".concat(ccKey, "ExtraArgs")
  };
};

exports.convertDataKeyToStateKeys = convertDataKeyToStateKeys;

var convertInputErrorToMessageError = function convertInputErrorToMessageError(error) {
  if (error && error.type === 'ApiInputError') {
    return (0, _first["default"])((0, _get["default"])((0, _first["default"])(error.payload), 'errors'));
  }

  if (error && error.message) {
    return error.message;
  }

  return error;
};

exports.convertInputErrorToMessageError = convertInputErrorToMessageError;

var listenToFetchActions = function listenToFetchActions(state, action, key) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!key && !action && !state) {
    return;
  } // save a lot of performance by checking key exists in action.type
  // save ca 500x camelCase function calls and a lot of new object and string (> 1000) for every reducer action being triggert


  if (action.type.indexOf(key) === 0) {
    var obj = convertDataKeyToStateKeys(key, options);

    switch (action.type) {
      case "".concat(key, "_PENDING"):
        var newPendingState = _objectSpread({}, state);

        newPendingState[obj.retrievingKey] = true;
        newPendingState[obj.errorKey] = null;
        newPendingState[obj.extraArgsKey] = action.extraArguments;

        if (options.retrieving) {
          options.retrieving(newPendingState);
        }

        return newPendingState;

      case "".concat(key, "_FULFILLED"):
        var newState = _objectSpread({}, state);

        newState[obj.retrievingKey] = false;

        if (options.response) {
          action.body = options.response(action.body, newState, action) || action.body || true;
        }

        newState[obj.responseKey] = action.body;
        return newState;

      case "".concat(key, "_ERROR"):
        var newErrorState = _objectSpread({}, state);

        newErrorState[obj.retrievingKey] = false;

        if (options.error) {
          action.body = options.error(action.body, newErrorState);
        }

        newErrorState[obj.errorKey] = action.body || true;

        if (action.response && obj.errorStatus) {
          newErrorState[obj.errorStatus] = action.response.status;
        }

        return newErrorState;

      case "".concat(key, "_RESET"):
        var newClearState = _objectSpread({}, state);

        delete newClearState[obj.retrievingKey];
        delete newClearState[obj.responseKey];
        delete newClearState[obj.errorKey];
        delete newClearState[obj.errorStatus];
        delete newClearState[obj.extraArgsKey];
        return newClearState;
    }
  }
};

exports.listenToFetchActions = listenToFetchActions;

var resetSubmitStates = function resetSubmitStates(state, key, options) {
  /* Note: this function doesn't return anything, it mutates the state that's
    passed in to it. I dont' know if this is supposed to be it's intended use.
  */
  if (!state || !key) {
    return;
  }

  var obj = convertDataKeyToStateKeys(key, options);
  state[obj.retrievingKey] = null;
  state[obj.responseKey] = null;
  state[obj.errorKey] = null;
};
/**
 * Convert fetch action events to redux state, given the fetch action key and redux state key.
 * @param {*} state your current reducer state
 * @param {*} action your reducer action
 * @param {*} fetchKey
 * @param {*} reduxKey
 * @return {object} the new redux state if it has changed, otherwise: null
 */


exports.resetSubmitStates = resetSubmitStates;

var listen = function listen(state, action, fetchKey, reduxKey) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  if (!state || !action || !fetchKey || !reduxKey) {
    return;
  } // save a lot of performance by checking fetchKey exists in action.type


  if (action.type.indexOf(fetchKey) === 0) {
    switch (action.type) {
      case "".concat(fetchKey, "_PENDING"):
        // if the initial state wasn't there we don't trigger an update by setting retrieving=true since the empty state already is reflecting that we are retrieving something, this prevents some initial re-renders of the containers
        // this behavior can be overridden by setting option.triggerRetrieving = true, only use if you want to show a loader when posting somemthing
        if (!options.triggerRetrieving && !options.retrieving && !state[reduxKey]) {
          return state;
        }

        var newPendingState = _objectSpread({}, state);

        newPendingState[reduxKey] = {
          retrieving: true,
          response: options.keepOldDataWhilePending ? (0, _get["default"])(newPendingState, reduxKey + '.response') : null
        };

        if (typeof options.retrieving === 'function') {
          options.retrieving(newPendingState);
        }

        return newPendingState;

      case "".concat(fetchKey, "_FULFILLED"):
        var newState = _objectSpread({}, state);

        newState[reduxKey] = {};

        if (options.response) {
          action.body = options.response(action.body, newState, action);
        }

        newState[reduxKey].response = action.body || true;
        return newState;

      case "".concat(fetchKey, "_ERROR"):
        var newErrorState = _objectSpread({}, state);

        newErrorState[reduxKey] = {};

        if (options.error) {
          action.body = options.error(action.body, newErrorState, action.response.status);
        }

        newErrorState[reduxKey].error = action.body || true;
        newErrorState[reduxKey].errorStatus = action.response.status;
        return newErrorState;

      case "".concat(fetchKey, "_RESET"):
        var newClearState = _objectSpread({}, state);

        delete newClearState.reduxKey;
        return newClearState;
    }
  }
};

exports.listen = listen;

var createReducer = function createReducer(initialState, handlers) {
  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}; // We need this for now.


exports.createReducer = createReducer;

var updateObject = function updateObject(oldObject, newValues) {
  // Encapsulate the idea of passing a new object as the first parameter
  // to Object.assign to ensure we correctly copy data instead of mutating
  return Object.assign({}, oldObject, newValues);
};

exports.updateObject = updateObject;